// AI Processing Status Component
// Shows processing status with live AI content preview for app creation

import "./AIProcessingStatus.css";
import { RevoltIcon } from "../../../components";

export function AIProcessingStatus({
  isProcessing,
  currentAttempt,
  maxAttempts,
  aiContent,
}) {
  const hasAIContent =
    aiContent &&
    (aiContent.title || aiContent.description || aiContent.startingMessage);

  // Show if currently processing OR if we have AI content to display
  if (!isProcessing && !hasAIContent) return null;

  return (
    <div className="ai-processing-status">
      {hasAIContent ? (
        <div className="ai-content-preview">
          {/* Header: Icon + Title */}
          <div className="ai-preview-header">
            <RevoltIcon name="cpu" size="lg" className="ai-preview-icon" />
            <div className="ai-preview-title-section">
              <span className="ai-preview-title">
                {aiContent.title || "Generating title..."}
              </span>
              {!aiContent.isComplete && (
                <span className="ai-preview-live">LIVE</span>
              )}
            </div>
          </div>

          {/* Content: Description + Instructions */}
          <div className="ai-preview-content">
            <div className="ai-preview-column">
              {aiContent.description && (
                <div className="ai-preview-field">
                  <div className="ai-field-label">Description</div>
                  <div className="ai-field-value">{aiContent.description}</div>
                </div>
              )}
            </div>

            <div className="ai-preview-column">
              {aiContent.startingMessage && (
                <div className="ai-preview-field">
                  <div className="ai-field-label">Instructions</div>
                  <div className="ai-field-value">
                    {aiContent.startingMessage}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="ai-processing-text">
          <RevoltIcon name="cpu" size="lg" className="ai-processing-icon" />
          <div className="ai-processing-text-content">
            <div className="ai-processing-main">
              AI is preparing your app...
            </div>
            {currentAttempt > 1 && (
              <div className="ai-processing-attempt">
                Attempt {currentAttempt} of {maxAttempts}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
